import * as Yup from "yup";

const password = Yup.string()
  .required(window.Drupal.t("Password is required"))
  .min(8, window.Drupal.t("Password must be 8 characters"))
  .matches(
    /^(?=.*[a-z])/,
    window.Drupal.t("Password must contain a lowercase letter")
  )
  .matches(
    /^(?=.*[A-Z])/,
    window.Drupal.t("Password must contain an uppercase letter")
  )
  .matches(/^(?=.*[0-9])/, window.Drupal.t("Password must contain a number"))
  .matches(
    /^(?=.*[!@#$%^&*])/,
    window.Drupal.t(
      "Password must contain one of the following symbols: !@#$%^&*"
    )
  );

const passwordConfirm = Yup.string()
  .required(window.Drupal.t("Confirm password is required"))
  .oneOf(
    [Yup.ref("password"), null],
    window.Drupal.t("Password does not match")
  );

export { password, passwordConfirm };
